<!--
Copyright 2026 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<crucible-dialog
  [dialogTitle]="(data.scale.id ? 'Edit' : 'Create') + ' Proficiency Scale'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.scale !== undefined && data.scale !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Proficiency Scale"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.scale.name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input
              type="text"
              title="The Description of the Proficiency Scale"
              matInput
              placeholder="Description"
              [(ngModel)]="data.scale.description">
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
